export default "__VITE_ASSET__Bpar4G2F__"